import { render } from "./create-invoice.vue?vue&type=template&id=6c71dcc5"
import script from "./create-invoice.vue?vue&type=script&lang=js"
export * from "./create-invoice.vue?vue&type=script&lang=js"

import "./create-invoice.vue?vue&type=style&index=0&id=6c71dcc5&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__